import HoverPopover from "./HoverPopover";
import { getPermissionMeta } from "../../constants/aclPermissionCatalog";

export default function AclPermissionPopover({ permission }) {
  const access = Number(permission?.access) || 0;
  if (access <= 0) return null;

  const value = permission?.value || permission?.permission;
  const meta = getPermissionMeta(value);
  const name = permission?.name || meta.name;
  const description = permission?.description ?? meta.description;

  return (
    <HoverPopover
      trigger={
        <span className="inline-block cursor-default text-sm text-gray-800 underline decoration-dotted decoration-gray-400 underline-offset-2">
          {name}
        </span>
      }
    >
      <div className="font-medium text-gray-900">{name}</div>
      {description ? (
        <div className="mt-1 text-xs text-gray-600">{description}</div>
      ) : null}
    </HoverPopover>
  );
}
